import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { Query } from '@apollo/client/react/components'
import LinearProgress from '@material-ui/core/LinearProgress'
import Error from '@components/error'
import richTextFragment from '@components/renderers/rich-text.fragment'
import Program from '@layouts/program/index'
import programFragment from '@layouts/program/program.fragment'
import Other from './other'

const WITH_PROMO_QUERY = gql`
query BySlug($slug: String, $preview: Boolean)  {
  pageCollection(limit: 1, preview: $preview, where: {slug: $slug})  {
    items {
      slug
      route2
      headline
      metaDescription
      image {
        url
        description
      }
      content {
        ${richTextFragment}
      }
    }
  }
  promotionalPageCollection(limit: 1, preview: $preview, where: {slug: $slug}) {
    items {
      ${programFragment}
    }
  }
}
`

export default function OtherWithData(props) {
  const { query, asPath } = props
  return (
    <Query query={WITH_PROMO_QUERY} variables={query}>
      {({
        loading, error, data,
      }) => {
        if (error) {
          return <Error error={error} displayErrorType="page" />
        }
        if (loading) return <LinearProgress color="secondary" />

        let Component = Other
        let response = data.pageCollection && data.pageCollection.items[0]

        if (response) {
          const routeFromData = response?.route2
          return asPath.includes(routeFromData) ? (
            <Component {...response} {...props} />
          ) : <Error statusCode={404} />
        }

        response = data.promotionalPageCollection && data.promotionalPageCollection.items[0]
        Component = Program
        return response ? (
          <Component {...response} {...props} />
        ) : <Error statusCode={404} />
      }}
    </Query>
  )
}

OtherWithData.propTypes = {
  query: PropTypes.object,
  asPath: PropTypes.string,
}
